import api from "@/services/api";

import {
  SET_GENRES,
  SET_GENRES_YEARS,
  SET_ARTISTS,
  SET_TRACKS,
  SET_ALBUMS
} from "@/store/mutation-types";

export default {
  async fetch({ commit }, { type, params }) {
    const { payload = {} } = await api.genres.fetch(type, params);
    const { genres = [], genre = {} } = payload;

    commit(SET_GENRES, type === "genre" ? [genre] : genres);

    return payload;
  },
  async tracks({ commit }, { params }) {
    const { payload = {} } = await api.genres.tracks(params);
    const { tracks = [] } = payload;

    commit(`tracks/${SET_TRACKS}`, tracks, { root: true });

    return payload;
  },
  async albums({ commit }, { params }) {
    const { payload = {} } = await api.genres.albums(params);
    const { albums = [] } = payload;

    commit(`albums/${SET_ALBUMS}`, albums, { root: true });

    return payload;
  },
  async artists({ commit }, { params }) {
    const { payload = {} } = await api.genres.artists(params);
    const { artists = [] } = payload;

    commit(`artists/${SET_ARTISTS}`, artists, { root: true });

    return payload;
  },
  async years({ commit }, { params }) {
    const { payload = {} } = await api.genres.years(params);
    const { years = [] } = payload;

    commit(SET_GENRES_YEARS, { genreId: params.id, years });

    return payload;
  }
};
